import Dashboard from "./pages/Dashboard";
import Login from "./pages/Login";

import MyHolidays from "./pages/Holidays/MyHolidays";
import CreateHoliday from "./pages/Holidays/CreateHoliday";
import HolidayReview from "./pages/Holidays/HolidayReview";
import ViewRequest from "./pages/Holidays/ViewRequest";

import HealthAndSafetyReview from "./pages/HealthAndSaftey/HealthAndSafetyReview";
import CreateReport from "./pages/HealthAndSaftey/CreateReport";

import SelectDate from "./pages/SelectDate";

import MultiLayerFolder from "./pages/Documents/MultiLayerFolder";
const routes = {
  dashboard: { path: "/", element: <Dashboard /> },
  home: { path: "/home", element: <Dashboard /> },
  login: { path: "/login", element: <Login /> },

  myHolidays: { path: "/my-holidays", element: <MyHolidays /> },
  myHolidaysCreate: { path: "/my-holidays/create", element: <CreateHoliday /> },
  myHolidaysReview: { path: "/my-holidays/review", element: <HolidayReview /> },
  myHolidaysViewRequest: {
    path: "/my-holidays/view-request",
    element: <ViewRequest />,
  },

  healthSafety: {
    path: "/health-and-safety",
    element: <HealthAndSafetyReview />,
  },
  healthSafetyCreate: {
    path: "/health-and-safety/create",
    element: <CreateReport />,
  },

  selectDate: { path: "/select-date", element: <SelectDate /> },

  documents: { path: "/documents", element: <MultiLayerFolder /> },
};

export default routes;
